require('./preGrantedCreditLegalConfirmation.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const BrowserUtils = require('utilities/browserUtils');

// @constants
const {
    preGrantedCredit: {
        CONTRACT_NAME,
    },
} = require('../../../../loansConstants/index');
const { PRE_CONTRACTUAL_OVERDRAFT_PROTECTION_MAIL } = require('constants/flagBasedFeatures');

// @commons components
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');

class PreGrantedCreditLegalConfirmation extends React.Component {

    constructor(props) {
        super(props);
        this.handleConfirmationChange = this.handleConfirmationChange.bind(this);
    }

    componentWillUnmount() {
        this.props.resetPrecontractualMail();
    }

    handleConfirmationChange() {
        const { updateConfirmationCheckbox } = this.props;
        updateConfirmationCheckbox();
    }

    openDynamicDocument(base64String) {
        const binaryString = Buffer.from(base64String.split(',')[1], 'base64');
        const currentBlob = new Blob([binaryString], { type: 'application/pdf' });

        if (BrowserUtils.browserIsIE()) {
            window.navigator.msSaveOrOpenBlob(currentBlob);
        } else {
            const blobURL = window.URL.createObjectURL(currentBlob);
            window.open(blobURL, '_blank');
        }
    }

    buildLabels() {
        const { immPreGrantedCredit } = this.props;

        const labels = [];
        labels.push(formatText('contractsView-preGrantedCreditServiceContractLabel1'));
        labels.push(
            <OKLink
                onClick={() => this.openDynamicDocument(immPreGrantedCredit.get('fileINEDocument'))}
                modifier="emphasize"
            >
                {formatText('contractsView-preGrantedCreditServiceContractLabel2')}
            </OKLink>
        );
        labels.push(formatText('contractsView-preGrantedCreditServiceContractLabel3'));
        labels.push(
            <OKLink
                target="_blank"
                to={formatText('contractsView-pdfLinkforCPS')}
                modifier="emphasize"
            >
                {formatText('contractsView-preGrantedCreditServiceContractLabel4')}
            </OKLink >
        );
        labels.push(formatText('contractsView-preGrantedCreditServiceContractLabel5'));

        return labels;
    }



    buildConfirmationCheckbox() {
        const { immPreGrantedCredit, preContractualMail } = this.props;
        const labels = this.buildLabels();
        const isContactCenter = __CONTACT_CENTER__;
        const isDisabled = isContactCenter
            ? !immPreGrantedCredit.get('isOverdraftEmailSent')
            : immPreGrantedCredit.get('checkboxFlag') || !preContractualMail.get('mailSent');
        return (
            <OKCheckbox
                idName="serviceContract"
                value={immPreGrantedCredit.get('confirmationCheckbox') || immPreGrantedCredit.get('checkboxFlag')}
                onChange={this.handleConfirmationChange}
                label={labels}
                errorState={!immPreGrantedCredit.get('confirmationCheckbox') && immPreGrantedCredit.get('confirmationCheckboxError')}
                errorMessage={!immPreGrantedCredit.get('confirmationCheckbox') && formatText('contractsView-serviceContractErrorMessage')}
                disabled={isDisabled}
            />
        );
    }

    buildAcceptanceLegal() {
        return (
            <div className="aceptacin-de-inform"><FormattedText value="contractsView-acceptanceLegalHeader" /></div>
        )
    }

    render() {
        const { immPreGrantedCredit, immProfile, preContractualMail, requestProfile, sendPreContractualMail,
            subType, type, standar, immFlagBasedFeatures, sendOverDraftSimpleEmail, getContractDraftDocument } = this.props;

        let content = null;
        const showAcceptanceLegalHeader = (immPreGrantedCredit.get('visibleStep') === 3);
        const showLegalTextStep1 = (__CONTACT_CENTER__ && immPreGrantedCredit.get('visibleStep') === 1);
        const mailAPIFlag = immPreGrantedCredit.get('mailAPIFlag');

        if (__CONTACT_CENTER__ && (immPreGrantedCredit.get('contractInformationStepOne') && immPreGrantedCredit.get('visibleStep') === 1) || immPreGrantedCredit.get('visibleStep') === 3) {
            const preGrantedCreditCCFlag = !!(__CONTACT_CENTER__ && immFlagBasedFeatures.get(PRE_CONTRACTUAL_OVERDRAFT_PROTECTION_MAIL) || immPreGrantedCredit.get('visibleStep') === 3);
            content = (
                <article className="pre-granted-credit-legal-confirmation">
                    <section className="contract-confirmation-step__confirmation-section">
                        {showAcceptanceLegalHeader && this.buildAcceptanceLegal()}
                        <PreContractualMailInfo
                            email={PersonalDataHelper.getEmail(immProfile)}
                            sendEmail={sendPreContractualMail}
                            requestProfile={requestProfile}
                            preContractualMail={preContractualMail}
                            profileError={immProfile.get('error')}
                            contractName={CONTRACT_NAME}
                            sendMailParams={{ subType, type, standar, undefined }}
                            showLegalText={showLegalTextStep1}
                            ccFlag={preGrantedCreditCCFlag}
                            sendSimpleEmail={sendOverDraftSimpleEmail}
                            mainFeatureFlag={true}
                            contractObj={immPreGrantedCredit}
                            getContractDraftDocument={getContractDraftDocument}
                            disableSendButton={!mailAPIFlag || immPreGrantedCredit.get('isOverdraftEmailInitError')}
                            mainFlag='OVERDRAFT_PROTECTION'
                            loadingSendButton={immPreGrantedCredit.get('isFetchingINEDocument')}
                        />
                        {preGrantedCreditCCFlag && this.buildConfirmationCheckbox()}
                    </section>
                </article>
            );
        }

        return content;
    }
}

PreGrantedCreditLegalConfirmation.propTypes = {
    immPreGrantedCredit: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    updateConfirmationCheckbox: PropTypes.func,
    sendPreContractualMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func,
    requestProfile: PropTypes.func,
    preContractualMail: PropTypes.object.isRequired,
    subType: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    standar: PropTypes.string.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    sendOverDraftSimpleEmail: PropTypes.func.isRequired,
    getContractDraftDocument: PropTypes.func.isRequired,
};

module.exports = PreGrantedCreditLegalConfirmation;
